<template>
  <div id="payment-detail">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header bg-transparent header-elements-inline">
                <h6 class="card-title">{{ this.$t("message.payDetails") }}</h6>
                <div class="header-elements">
                  <el-button-group>
                    <el-tooltip v-if="data.paymentStatus == 0" class="item" effect="dark" :content="$t('event.table.approve')" placement="top-start">
                      <el-button @click="changePaymentStatus({ item: data, status: 1 })" icon="el-icon-check" size="mini" type="success"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('event.table.abort')" placement="top-start">
                      <el-popconfirm v-if="data.paymentStatus != 2" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.variables.no')" icon="el-icon-info" iconColor="red" :title="$t('message.sureCancel')" @confirm="changePaymentStatus({ item: data, status: 2 })">
                        <el-button slot="reference" icon="el-icon-warning-outline" size="mini" type="danger"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </el-button-group>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="mb-4">
                      <div class="text-sm-right">
                        <h4 class="text-primary mb-2 mt-md-2">{{ this.$t("event.filter.paymentID") }} #{{ data.paymentID }}</h4>
                        <ul class="list list-unstyled mb-0">
                          <li>
                            {{ this.$t("event.table.registerDate") }}:
                            <span class="font-weight-semibold">
                              {{ $moment(data.createDate).format("DD MMMM YYYY, dddd HH:mm") }}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-md-flex flex-md-wrap">
                  <div class="mb-4 mb-md-2">
                    <span class="text-muted">{{ this.$t("customerInfo") }}:</span>
                    <ul class="list list-unstyled mb-0">
                      <li>
                        <h5 class="my-2">{{ data.customerName }}</h5>
                      </li>
                      <li>
                        {{ this.$t("phone") }}:
                        <a :href="'tel:' + data.customerPhoneNumber">
                          {{ data.customerPhoneNumber }}
                        </a>
                      </li>
                      <li>
                        {{ this.$t("mail") }}:
                        <a :href="'mailto:' + data.customerEmail">
                          {{ data.customerEmail }}
                        </a>
                      </li>

                      <li>
                        <span class="font-weight-semibold">
                          {{ $enums.invoiceType.find((k) => k.value == data.invoiceType).title }}
                        </span>
                      </li>

                      <li>{{ this.$t("bill") }}: {{ data.invoiceTitle1 }}</li>
                      <li>{{ this.$t("bill") }}: {{ data.invoiceTitle2 }}</li>
                      <li>{{ this.$t("bill") }}: {{ data.invoiceTitle3 }}</li>
                      <li>{{ this.$t("bill") }}: {{ data.invoiceTitle4 }}</li>
                    </ul>
                  </div>

                  <div class="mb-2 ml-auto">
                    <span class="text-muted">{{ this.$t("summary") }} :</span>
                    <div class="d-flex flex-wrap wmin-md-400">
                      <div class="table-responsive">
                        <table class="table">
                          <tbody>
                            <tr>
                              <th>{{ this.$t("event.table.status") }}</th>
                              <td class="text-right">
                                <p class="text-info" v-if="data.paymentStatus == 0">
                                  {{ $enums.paymentStatus.find((k) => k.value == data.paymentStatus).title }}
                                </p>
                                <p class="text-success" v-if="data.paymentStatus == 1">
                                  {{ $enums.paymentStatus.find((k) => k.value == data.paymentStatus).title }}
                                </p>
                                <p class="text-danger" v-if="data.paymentStatus == 2">
                                  {{ $enums.paymentStatus.find((k) => k.value == data.paymentStatus).title }}
                                </p>
                                <span v-if="data.paymentStatus == 1">
                                  {{ $moment(data.confirmationDate).format("DD MMMM YYYY, HH:mm") }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <th>{{ this.$t("paymentType") }}</th>
                              <td class="text-right">
                                <span>
                                  {{ $enums.paymentType.find((k) => k.value == data.paymentType).title }}
                                </span>
                              </td>
                            </tr>

                            <tr v-if="data.paymentType == 3">
                              <th>{{ this.$t("transferCode") }}</th>
                              <td class="text-right">
                                <span>
                                  {{ data.paymentID }}
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <th>{{ this.$t("decimatedTotal") }}:</th>
                              <td class="text-right">
                                {{ $formatMoney(data.price) }}
                                {{ $enums.currency.find((k) => k.value == data.currency).title }}
                              </td>
                            </tr>
                            <tr>
                              <th>{{ this.$t("discounts") }}:</th>
                              <td class="text-right">
                                {{ $formatMoney(data.discountPrice) }}
                                {{ $enums.currency.find((k) => k.value == data.currency).title }}
                              </td>
                            </tr>
                            <tr>
                              <th>
                                {{ this.$t("taxes") }}:
                                <span class="font-weight-normal">({{ data.taxRate }} %)</span>
                              </th>
                              <td class="text-right">
                                {{ $formatMoney(data.paidPrice) }}
                                {{ $enums.currency.find((k) => k.value == data.currency).title }}
                              </td>
                            </tr>
                            <tr>
                              <th>{{ this.$t("total") }}:</th>
                              <td class="text-right">
                                {{ $formatMoney(data.paidPrice) }}
                                {{ $enums.currency.find((k) => k.value == data.currency).title }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-lg">
                  <thead>
                    <tr>
                      <th>{{ this.$t("general") }}</th>
                      <th>{{ this.$t("pack") }}</th>
                      <th>{{ this.$t("tag") }}</th>
                      <th>{{ this.$t("daySelection") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h6 class="mb-0">{{ data.customerName }}</h6>
                        <span class="text-muted">ID: {{ participant.participantNO }}</span>
                      </td>
                      <td>
                        <span>
                          {{ $store.state.packets.items.find((k) => k.id == data.packetID).title }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ $store.state.tags.items.find((k) => k.id == participant.tagID).title }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ data.dayRestriction == null ? $t("noRestriction") : $moment(data.dayRestriction).format("DD MMMM YYYY") }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p v-for="input in participant.registrationInputs" :key="input.id">
                          <b>
                            {{ $store.state.participants.registrationInputs.find((k) => k.id == input.registrationInputID).title }}
                          </b>
                          {{ input.answer }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <template v-if="$i18n.locale == 'tr'">
                  <span class="text-muted">
                    Bu kayıt
                    {{ $moment(data.createDate).format("DD MMMM YYYY, dddd HH:mm") }}
                    tarihinde {{ data.ipAddress }} IP adresinden yapılmıştır.
                  </span>
                </template>
                <template v-else>
                  <span class="text-muted">
                    This entry was made on
                    {{ $moment(data.createDate).format("DD MMMM YYYY, dddd HH:mm") }}
                    ,from IP address {{ data.ipAddress }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaymentDetail",
    props: ["data", "participant"],
    methods: {
      changePaymentStatus(payload) {
        var index = this.$store.state.payments.items.findIndex((k) => k.id == this.participant.id)
        var paymentIndex = this.$store.state.payments.items[index].paymentInfos.findIndex((k) => k.id == this.data.id)

        this.$store.dispatch("changePaymentStatus", {
          ...payload,
          context: this,
          index,
          paymentIndex,
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/PaymentDetail.vue